
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSpeedHalfDown as ObiSpeedHalfDownElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-speed-half-down.js';
 
 
 

 
 export const ObiSpeedHalfDown = createComponent({
   react: React,
   tagName: 'obi-speed-half-down',
   elementClass: ObiSpeedHalfDownElement,
   events: {
     
   }
  });
 
 